export const INITIAL_MODE = 'initial';
export const LIVE_MODE = 'live';
export const REWIND_MODE = 'timescrubbing';

export const TOGGLE = 'toggle';
export const COMPLETED = 'completed';
